import { Help } from './components/help'
import { Routes, Route, BrowserRouter } from 'react-router-dom'

// Code-splitting is automated for `routes` directory
import Travel from './routes/travel'
import TravelLocation from './routes/travelLocation'
import './style/index.css'

// document.querySelector('body').classList.add('darkTheme')
// const style = document.createElement('style')
// style.innerHTML = 'body.darkTheme { background: #000; }'
// document.querySelector('head').append(style)

const TravelApp = () => {
    return (
        <div id="travel-wrap">
            <Help />
            <Routes>
                <Route path="/matkakohteet" element={<Travel />} />
                <Route path="/matkakohteet/maa/:countryId" element={<Travel />} />
                <Route path="/matkakohteet/:id" element={<TravelLocation />} />
            </Routes>
        </div>
    )
}

export default function App() {
    return (
        <BrowserRouter>
            <TravelApp />
        </BrowserRouter>
    )
}
